module.exports = __webpack_public_path__ + "static/media/transfer.39caaa03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/ssp2/transfer.svg
// module id = 498
// module chunks = 0